/**
 * V192.4: Profile Stats Cache Utility
 * 
 * CRITICAL: This file exists ONLY to break the circular dependency between
 * Profile.tsx and NetworkDataContext.tsx
 * 
 * CIRCULAR DEPENDENCY ISSUE:
 * - Profile.tsx imports hooks from NetworkDataContext.tsx
 * - NetworkDataContext.tsx needs to call clearProfileStatsCache()
 * - If NetworkDataContext imports from Profile.tsx → CIRCULAR DEPENDENCY
 * 
 * SOLUTION:
 * - Extract ONLY clearProfileStatsCache() to this standalone utility
 * - NetworkDataContext imports from here (no circular dependency)
 * - Profile.tsx can keep its own cache functions (getCached, setCached)
 */

// V167.STATIC: Session storage key for profile stats cache
const SESSION_CACHE_KEY = 'v167_profile_stats_cache';

/**
 * Clear profile stats cache from sessionStorage
 * 
 * Called by NetworkDataContext when connections change to force recalculation
 * of trust scores and network stats.
 */
export function clearProfileStatsCache(): void {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  
  try {
    window.sessionStorage.removeItem(SESSION_CACHE_KEY);
    console.log('🎯 V167.STATIC: Profile stats cache cleared');
  } catch (error) {
    console.error('❌ V167.STATIC: Error clearing cache:', error);
  }
}

